import { PermissionsScope } from '../../policies/policy.model'

export const GOODS_RETURN_FRAGMENT = 'goods-return'
export const GOODS_RETURN_SCOPE: PermissionsScope = 'goodsReturns'
export const GOODS_RETURN_SYSTEM_TAGS: string[] = ['#partial']
